var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewCustomerSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "30,7 25,7 25,2 23,2 23,7 18,7 18,9 23,9 23,14 25,14 25,9 30,9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0737305,21.5244141C17.5673828,20.9550781,14.5151367,20,11,20s-6.5673828,0.9550781-8.0732422,1.5244141 C1.7744141,21.9589844,1,23.0849609,1,24.3261719V30h2v-5.6738281c0-0.4140625,0.2543945-0.7880859,0.6333008-0.9306641 C5.012207,22.8740234,7.8027344,22,11,22s5.987793,0.8740234,7.3671875,1.3955078 C18.7456055,23.5380859,19,23.9121094,19,24.3261719V30h2v-5.6738281C21,23.0849609,20.2255859,21.9589844,19.0737305,21.5244141z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,18c2.8530273,0,5-4.2460938,5-7c0-3.0371094-1.9624023-5-5-5s-5,1.9628906-5,5C6,13.7539062,8.1469727,18,11,18z M11,8 c1.9345703,0,3,1.0654297,3,3c0,2.1025391-1.7382812,5-3,5s-3-2.8974609-3-5C8,9.0654297,9.0654297,8,11,8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCustomerSmall);
export default __webpack_public_path__ + "static/media/new-customer--small.a192c3f525300dcc90d1e7ee24850cdc.svg";
export { ForwardRef as ReactComponent };